export default "__VITE_ASSET__DGFGTz2t__"